import { render } from "./DialogLoadDatabankIntoDitribution.vue?vue&type=template&id=7b5ed3d8"
import script from "./DialogLoadDatabankIntoDitribution.vue?vue&type=script&lang=js"
export * from "./DialogLoadDatabankIntoDitribution.vue?vue&type=script&lang=js"

import "./DialogLoadDatabankIntoDitribution.vue?vue&type=style&index=0&id=7b5ed3d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__